// extracted by mini-css-extract-plugin
module.exports = {"lightBlue":"#3d7ffc","hoverBlue":"#094dcf","darkBlue":"#0e2548","navHover":"#1f4589","fillBlue":"#ecf2ff","exportViewTitle":"-export-button-exportViewTitle-20lzL6-"};